import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase.config';

/**
 * Fetches the user's remote cart and wishlist from Firestore
 */
export const fetchUserData = async (userId) => {
  if (!userId) return { cart: [], wishlist: [] };

  try {
    const userRef = doc(db, 'users', userId);
    const snap = await getDoc(userRef);

    if (snap.exists()) {
      const data = snap.data();
      return {
        cart: Array.isArray(data.cart) ? data.cart : [],
        wishlist: Array.isArray(data.wishlist) ? data.wishlist : [],
      };
    }
  } catch (error) {
    console.error('Failed to load user cart and wishlist from Firestore:', error);
  }

  return { cart: [], wishlist: [] };
};

/**
 * Saves user's cart and wishlist to Firestore with merge
 */
export const syncUserData = async (userId, { cart, wishlist }) => {
  if (!userId) return;

  try {
    const userRef = doc(db, 'users', userId);
    const updatePayload = {
      lastSync: new Date().toISOString(),
    };

    if (cart !== undefined) updatePayload.cart = cart;
    if (wishlist !== undefined) updatePayload.wishlist = wishlist;

    await setDoc(userRef, updatePayload, { merge: true });
  } catch (error) {
    console.error('Failed to sync user data to Firestore:', error);
  }
};
